export default __webpack_public_path__ + "static/media/tsla-token.9f1a6afc.png";